import { Artist, ArtistRole, Patch } from '@hooks/useAlbumInfo/types';
import {
  MusicVideo,
  UnclearedVideosResult,
} from '@hooks/useShowUnclearedVideos/types';

export type UnclearedVideosFormatted = {
  albumUri: string;
  albumCoverArtImage: string;
  trackName: string;
  artists: Artist[];
  isrc: string;
  upc: string;
  uri: string;
  url: string;
  release: string;
  releaseDate: string;
  patches: Patch[];
  batchId: string;
  deliveryDate: string;
};

export const formatUnclearedVideosData = (
  unclearedVideos: UnclearedVideosResult['data']['video'],
): UnclearedVideosFormatted[] => {
  return unclearedVideos
    .map((video: MusicVideo) => {
      if (video.trackDetails) {
        const artists = video.trackDetails.artists.filter(({ role }) =>
          [
            ArtistRole.MAIN_ARTIST,
            ArtistRole.FEATURED_ARTIST,
            ArtistRole.REMIXER,
          ].includes(role),
        );
        const mappedVideo = {
          albumUri: video.trackDetails.albumUri,
          albumCoverArtImage: video.trackDetails.albumCoverArtImage,
          trackName: video.trackDetails.name,
          artists: artists,
          isrc: video.trackDetails.isrc,
          upc: '',
          uri: video.uri,
          url: video.trackDetails.url,
          release: video.trackDetails.name,
          releaseDate: video.trackDetails.earliestLiveDate,
          patches: video.clearanceStatus,
          batchId: video.batchId,
          deliveryDate: video.deliveryDate,
        };
        if (video.trackDetails.identifiers.length) {
          mappedVideo.upc =
            video.trackDetails.identifiers.find(
              identifier => identifier.type === 'UPC',
            )?.value || '';
        }

        return mappedVideo;
      }

      return null as any;
    })
    .filter(unclearedVideo => !!unclearedVideo);
};

export const getLoadingSkeletonData = (
  rowAmount: number,
): UnclearedVideosFormatted[] => {
  return Array(rowAmount).fill({
    albumUri: '',
    albumCoverArtImage: '',
    trackName: '',
    artists: [] as Artist[],
    isrc: '',
    upc: '',
    uri: '',
    url: '',
    release: '',
    releaseDate: '',
    patches: [],
  });
};
